import { CreateReportRequest } from '@api';
import { MapCreateReportRequestProps } from './mapCreateReportRequest.types';
import { mapBaseReportBody } from '../../../../helpers';
import { COMPOUND_STATUS_FILTER_BY_ORDER_STATUS } from '../../../CompoundFiltersContainer/CompoundFiltersContainer.constants';

export const mapCreateReportRequest = ({
  visibleColumns,
  compoundFilterState,
  filters,
  name,
}: MapCreateReportRequestProps) => {
  const request: CreateReportRequest = {
    body: mapBaseReportBody({ visibleColumns, compoundFilterState, filters, name }),
  };

  // map status filter to compound filter when user is located in status tab and has selected status from sidebar
  if (
    request.body?.compoundFilterState?.selectedOptionIndexs?.[0]?.length &&
    request.body?.filter.status?.length
  ) {
    request.body.compoundFilterState.selectedOptionIndexs[0] = request.body.filter.status.map(
      (status) =>
        COMPOUND_STATUS_FILTER_BY_ORDER_STATUS.ALL.options.findIndex(
          // @ts-expect-error - getting any value types
          ({ value: optionValue }) => optionValue === status,
        ),
    );
  }

  return request;
};
